import React from "react";
import { InputCurrencyWithSuffixFloatingLabelHelpers } from "./Shared";

export function CurrencyInputDisabled({
  label,
  value,
  suffix,
}) {
  return (
    <InputCurrencyWithSuffixFloatingLabelHelpers
      value={value}
      label={label}
      id={label}
      suffix={suffix}
      disabled={true}
    />
  );
}
